/**
 * Adhoc Points Interfaces
 */

/**
 * Adhoc Points Item
 */
export interface AdhocPoint {
  id: number;
  name: string;
  excel_url: string;
  proof_attachment_url: string;
  points_method: number;
  points_type: number;
  status: number;
  program_id: number;
  created_date: string;
  rejected_reason: string | null;
  batch_rejected_response: string | null;
  points_method_string: string;
  points_type_string: string;
  status_sting: string;
}

/**
 * Adhoc Points List Response
 */
export interface AdhocPointsListResponse {
  success: boolean;
  status: number;
  data: {
    data: AdhocPoint[];
  };
}

/**
 * Adhoc Upload Form Data (NEW FORMAT)
 */
export interface AdhocUploadFormData {
  program_id: string | number;
  batch_name: string;
  points_method: number;
  points_type: number;
  validation_type: number;
  excel_file: File;
  proof_file: File;
  user_group_id: number;
  module_id: number;
}

/**
 * User Type for Enrollment
 */
export interface UserType {
  id: number;
  role_full_name: string;
  role_short_name: string;
}

/**
 * User Group for Enrollment
 */
export interface UserGroup {
  user_group_id: number;
  group_name: string;
  enrollment_setting_id: number;
  setting_name: string;
  setting_code: string;
  enrollment_type: string;
}

/**
 * Module for User Group
 */
export interface Module {
  id: number;
  module_name: string;
  module_code?: string;
  status?: number;
}

/**
 * User Types Response
 */
export interface UserTypesResponse {
  success: boolean;
  status: number;
  data: {
    program_id: number;
    program_name: string;
    total: number;
    user_types: UserType[];
  };
}

/**
 * User Groups Response
 */
export interface UserGroupsResponse {
  success: boolean;
  status: number;
  data: {
    user_type_id: number;
    program_id: number;
    total: number;
    user_groups: UserGroup[];
  };
}

/**
 * Modules Response
 */
export interface ModulesResponse {
  success: boolean;
  status: number;
  data:
    | {
        modules: Module[];
      }
    | Module[];
}

/**
 * Adhoc Upload Response
 */
export interface AdhocUploadResponse {
  message: string;
  success_count: number;
  rejected_count: number;
  rejected_data: Array<{
    'Mobile Number'?: string;
    'User ID'?: string;
    message: string;
  }>;
  adhoc_id: number;
}

/**
 * Adhoc Approve Response
 */
export interface AdhocApproveResponse {
  success: boolean;
  status: number;
  data: {
    job_id: string;
    status: string;
    message: string;
    batch_name: string;
    adhoc_batch_id: number;
    check_status_url: string;
  };
}

/**
 * Adhoc Approve Payload
 */
export interface AdhocApprovePayload {
  adhoc_id: number;
}

/**
 * Dropdown Options
 */
export interface AdhocDropdownOption {
  id: number;
  name: string;
}
